export const selectTheme = (theme) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: "#125F3F",
      primary25: "#b1cab3",
      primary50: "#b1cab3",
    },
  });
  
  export const greenTheme = {
    borderColor: "#125f3f",
    boxShadow: "0 0 0 1px #125f3f",
  }